export default {
	title: null,
	delay: 0,
	grid: [],
	isVisible: true,
};
